type IconProps = React.ComponentProps<'svg'>

export function Moon01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.59668 0.06652c0.28432-0.12853 0.61918-0.06728 0.83984 0.15332 0.2204 0.22059 0.28067 0.55468 0.15235 0.83887-0.5509 1.21817-0.8574 2.57159-0.85742 3.99804 0.00006 5.36388 4.34804 9.71186 9.71191 9.71192 1.42651 0 2.77984-0.3065 3.99805-0.85742 0.28417-0.12835 0.61825-0.06801 0.83886 0.15234 0.22065 0.22065 0.28183 0.5555 0.15332 0.83984-1.75857 3.88859-5.67337 6.59668-10.22168 6.59668-6.19207-0.00021-11.2117-5.01984-11.21191-11.21191 0.00006-4.54824 2.70814-8.46313 6.59668-10.22168z m-1.04883 2.33203c-2.45185 1.76357-4.0478 4.64071-4.04785 7.88965 0.00021 5.36365 4.34827 9.7117 9.71191 9.71191 3.24908 0 6.12509-1.59684 7.88868-4.04882-0.85227 0.20719-1.74221 0.31738-2.65723 0.31738-6.1923-0.00006-11.21186-5.01961-11.21191-11.21192 0.00001-0.91521 0.10912-1.80577 0.3164-2.6582z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
